import { PLATFORMS } from 'constants/general';
import { ROUTES } from 'constants/routes';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';
import { platformSelector } from 'store/reducer/setting/selectors';
import { getBrowseMorePacksUrl, isRouteEmbedded } from 'utils/routes.util';

const BrowseMorePacks = () => {
  const { platform } = useAppSelectorShallow(platformSelector);
  const marketplaceUrl = getBrowseMorePacksUrl();

  const openMarketplaceInBrowserForMacApp = useCallback(() => {
    platform === PLATFORMS.MAC &&
      window.webkit.messageHandlers.open_marketplace.postMessage(
        marketplaceUrl
      );
  }, [platform]);

  return (
    <div className=' flex flex-col justify-center items-center text-center ~text-sm/base ~gap-1/2'>
      <p className='~text-xs/base'>{t('market.browse_more_packs')}</p>
      {!isRouteEmbedded ? (
        <Link to={ROUTES.MARKETPLACE}>
          <span className='inline-flex item-center justify-center px-3 text-primary-900 underline underline-offset-2'>
            {t('market.go_to_marketplace')}
          </span>
        </Link>
      ) : (
        <a
          href={marketplaceUrl}
          target='_blank'
          rel='noreferrer'
          className='inline-flex item-center justify-center px-3 text-primary-900 underline underline-offset-2'
          onClick={openMarketplaceInBrowserForMacApp}>
          {t('market.go_to_marketplace')}
        </a>
      )}
    </div>
  );
};

export default BrowseMorePacks;
